import { Button } from "react-bootstrap";
import Style from "./index.module.css";
import { useRouteMatch } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import throttle from "../../Utils/throttle";
// import debounce from "../../Utils/debounce";
import { changeTab } from "../../actions/tab";
import { updateLog } from "../../actions/log";
import { setSubmissions } from "../../actions/submissions";
import { useMemo } from "react";
import datetime from "../../Utils/date";
import getProblemForCurrentURL from "../../hooks/problem";

const Pagination = () => {
  const { params } = useRouteMatch();
  const { problemUrl } = params;
  const problemFiltered = getProblemForCurrentURL(params);
  const { test } = problemFiltered;
  const code = useSelector((state) => {
    return state.editor[problemUrl];
  });

  const dispatch = useDispatch();

  const handleClick = () => {
    //Change tab
    dispatch(changeTab("submission"));

    //Get result
    const result = test(code);

    //If all test cases passed
    if (result.status === "success") {
      dispatch(setSubmissions({ problemId: problemUrl }));
    }

    //Update log
    dispatch(
      updateLog({
        problemId: problemUrl,
        status: { dateTime: datetime(), result },
      })
    );
  };

  const throttledEventHandler = useMemo(
    () => throttle(handleClick, 1500),
    [code]
  );

  return (
    <div className={Style.submitButton}>
      <Button variant="success" onClick={throttledEventHandler}>
        Submit
      </Button>
    </div>
  );
};

export default Pagination;
